if (!customElements.get('gg-cart-recommendations')) {
  customElements.define(
    'gg-cart-recommendations',
    class GGCartRecommendations extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.load();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      async load() {
        const url = this.dataset.url;
        const slot = this.querySelector('[data-gg-recommendations-slot]');
        if (!url || !slot || this.dataset.loaded === 'true') return;

        this.dataset.loaded = 'loading';
        this.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);

          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const results = documentFragment.querySelector('[data-gg-cart-recommendations-results]');
          const items = results?.querySelectorAll('.gg-cart-recommendation');

          if (!results || !items?.length) {
            this.dataset.loaded = 'empty';
            return;
          }

          slot.replaceChildren(results);
          this.hidden = false;
          this.dataset.loaded = 'true';
        } catch (error) {
          if (error.name !== 'AbortError') this.dataset.loaded = 'error';
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const checkoutButton = event.target.closest('[data-gg-event="begin_checkout"]');
  if (!checkoutButton) return;
  checkoutButton.dataset.ggCheckoutReady = 'true';
});
